import { Component, inject } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { GlobalConfigService } from '../../services/global-config.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  public globalConfig = inject(GlobalConfigService);
  readonly router = inject(Router);

  goToSection(sectionID: string, routeUrl?: string){
    if(routeUrl){
      this.router.navigate([routeUrl]).then(() => {
        setTimeout(() => {
          document.getElementById(sectionID)?.scrollIntoView({behavior: 'smooth'});
        },50)
      });
      return;
    }

    document.getElementById(sectionID)?.scrollIntoView({behavior: 'smooth'});
  }
}
